angular.module('zc.projects')

.controller 'AddCouponsModalCtrl', ($scope, $state, $modalInstance, Campaign, campaign, parentController) ->
  $scope.campaign = campaign
  $scope.incentive = {}
  $scope.createIncentive = ->
    Campaign.addCouponCode
      project_id: campaign.project_id
      campaign_id: campaign.id
      incentive: $scope.incentive
    .then ->
      parentController.refreshCampaign()
      $modalInstance.close()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/add_coupons_modal.controller.js.coffee